
    import { Options, Vue } from 'vue-class-component';
    import $ from 'jquery';
    import HelloWorld from '@/components/HelloWorld.vue';
    import Basic from '@/components/customer/Basic.vue';
    import Rightside from '@/components/customer/Rightside.vue';
    import Beneficiary from '@/components/customer/Beneficiary.vue'; 
    import Common from '@/services/common.js'; 
    import moment from 'moment';
    
    import Toast from '@/components/Toast.vue'; 
    import Axios from "axios";   
    import { Form, Field,ErrorMessage } from 'vee-validate';
 
    import Select2 from 'vue3-select2-component'; 
    import { useToast } from "vue-toastification"; 
    import { useRoute } from 'vue-router';
 
    @Options({
        components: {
            'toasti':Toast, 
            'select2':Select2, 
            'beneficiary':Beneficiary, 
            HelloWorld, 
            'right-side':Rightside,
            Basic,
            Form,
            Field,
            ErrorMessage
        },
    })
    export default class Debit extends Vue { 
        STORAGE_KEY = "caprock-local";   
        user_name = '';

        selected_ac_name = ''; 
        user_info = {}; 
        form = {}; 
        token='';
        active_tab = 'account';
        customer_accounts   =   []; 
        total_ac_balance    =   0; 
        docs :any =  [];
        local_storage:any;
        dashboard = {
            currencies:[]
        }; 
        timer :any= undefined;

        load_on:any=0;

        uToken :any         =   '';  
        link_code :any      =   ''; 
        url_paras           =   {};


        request_verified:any    =   0;
        fresh_step      :any    =   0;
        completed_steps :any    =   [];
        users           :any    =   [];
        beneficiary     :any    =   []; 
        banks           :any    =   [];
        beneficiary_info:any    =   {};
        new_beneficiary_id:any  =   0;
        currencies      :any    =   [];
        current_step    :any    =   1;  
        cash_accounts   :any    =   []; 
        securities_accounts :any = []; 
        next_step:any           =   0;
        records         :any    =   {};
        req_details     :any    =   {}; 
        countries       :any    =   [];
        final_step      :any    =   5;


        value:any = 45;
        max:any=100;

        svg_image:any='<svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 100 100" width="50px" height="50px">    <path d="M 34.179688 10.164062 C 32.103687 10.164062 30.615234 11.426266 30.615234 13.697266 L 30.648438 25.806641 C 30.648438 28.846641 32.770234 30.712891 35.615234 30.712891 C 38.460234 30.712891 40.615234 29.002891 40.615234 25.962891 L 40.615234 14.306641 L 39.613281 14.306641 L 39.523438 25.869141 C 39.523438 28.079141 37.599438 29.808594 35.648438 29.808594 C 33.697437 29.808594 31.615234 28.049844 31.615234 25.839844 L 31.644531 13.611328 C 31.644531 12.304328 33.077484 11.126953 34.271484 11.126953 C 35.465484 11.126953 36.615234 12.275031 36.615234 13.582031 L 36.615234 24.056641 C 36.615234 24.056641 36.139813 25.056641 35.632812 25.056641 C 35.125812 25.056641 34.486234 24.700391 34.615234 24.150391 L 34.615234 14.308594 L 33.615234 14.308594 L 33.582031 23.964844 C 33.582031 25.344844 34.32225 25.964844 35.65625 25.964844 C 36.99025 25.964844 37.615234 25.249141 37.615234 23.869141 L 37.615234 13.664062 C 37.615234 11.393062 36.255687 10.164062 34.179688 10.164062 z M 41.613281 11.306641 C 41.061281 11.306641 40.613281 11.754641 40.613281 12.306641 C 40.613281 12.858641 41.061281 13.306641 41.613281 13.306641 L 59.613281 13.306641 L 59.613281 23.792969 C 59.613281 29.039969 63.881906 33.306641 69.128906 33.306641 L 79.613281 33.306641 L 79.613281 82.574219 C 79.613281 86.837219 76.146812 90.306641 71.882812 90.306641 L 28.347656 90.306641 C 24.084656 90.306641 20.615234 86.838219 20.615234 82.574219 L 20.615234 21.039062 C 20.615234 16.776063 24.083656 13.308594 28.347656 13.308594 L 29.615234 13.308594 C 30.167234 13.308594 30.615234 12.860594 30.615234 12.308594 C 30.615234 11.756594 30.167234 11.308594 29.615234 11.308594 L 28.347656 11.308594 C 22.981656 11.308594 18.615234 15.672062 18.615234 21.039062 L 18.615234 82.574219 C 18.615234 87.940219 22.980656 92.306641 28.347656 92.306641 L 71.882812 92.306641 C 77.248812 92.306641 81.613281 87.940219 81.613281 82.574219 L 81.613281 32.554688 C 81.613281 32.289688 81.508313 32.035656 81.320312 31.847656 L 61.072266 11.599609 C 60.885266 11.411609 60.630234 11.306641 60.365234 11.306641 L 41.613281 11.306641 z M 60.613281 13.966797 L 78.951172 32.306641 L 69.128906 32.306641 C 64.433906 32.306641 60.613281 28.487969 60.613281 23.792969 L 60.613281 13.966797 z M 28.371094 19.505859 C 28.245219 19.481734 28.110094 19.505984 27.996094 19.583984 C 25.878094 21.023984 24.613281 23.406078 24.613281 25.955078 L 24.613281 78.617188 C 24.613281 82.856187 28.048484 86.306641 32.271484 86.306641 L 67.955078 86.306641 C 72.178078 86.306641 75.613234 82.856188 75.615234 78.617188 L 75.615234 60.806641 C 75.615234 60.530641 75.391234 60.306641 75.115234 60.306641 C 74.839234 60.306641 74.615234 60.530641 74.615234 60.806641 L 74.615234 78.617188 C 74.615234 82.305187 71.628031 85.306641 67.957031 85.306641 L 32.273438 85.306641 C 28.602438 85.306641 25.615234 82.305188 25.615234 78.617188 L 25.615234 25.955078 C 25.615234 23.737078 26.714594 21.664156 28.558594 20.410156 C 28.786594 20.255156 28.846406 19.945797 28.691406 19.716797 C 28.613906 19.603297 28.496969 19.529984 28.371094 19.505859 z M 75.113281 47.306641 C 74.837281 47.306641 74.613281 47.530641 74.613281 47.806641 L 74.613281 50.806641 C 74.613281 51.082641 74.837281 51.306641 75.113281 51.306641 C 75.390281 51.306641 75.613281 51.082641 75.613281 50.806641 L 75.613281 47.806641 C 75.613281 47.530641 75.389281 47.306641 75.113281 47.306641 z M 30.113281 51.306641 C 29.837281 51.306641 29.613281 51.530641 29.613281 51.806641 C 29.613281 52.082641 29.837281 52.306641 30.113281 52.306641 L 53.113281 52.306641 C 53.390281 52.306641 53.613281 52.082641 53.613281 51.806641 C 53.613281 51.530641 53.389281 51.306641 53.113281 51.306641 L 30.113281 51.306641 z M 75.113281 52.306641 C 74.837281 52.306641 74.613281 52.530641 74.613281 52.806641 L 74.613281 58.806641 C 74.613281 59.082641 74.837281 59.306641 75.113281 59.306641 C 75.390281 59.306641 75.613281 59.082641 75.613281 58.806641 L 75.613281 52.806641 C 75.613281 52.530641 75.389281 52.306641 75.113281 52.306641 z M 30.113281 58.306641 C 29.837281 58.306641 29.613281 58.530641 29.613281 58.806641 C 29.613281 59.082641 29.837281 59.306641 30.113281 59.306641 L 44.113281 59.306641 C 44.390281 59.306641 44.613281 59.082641 44.613281 58.806641 C 44.613281 58.530641 44.389281 58.306641 44.113281 58.306641 L 30.113281 58.306641 z M 46.113281 58.306641 C 45.837281 58.306641 45.613281 58.530641 45.613281 58.806641 C 45.613281 59.082641 45.837281 59.306641 46.113281 59.306641 L 70.113281 59.306641 C 70.390281 59.306641 70.613281 59.082641 70.613281 58.806641 C 70.613281 58.530641 70.389281 58.306641 70.113281 58.306641 L 46.113281 58.306641 z M 30.113281 65.306641 C 29.837281 65.306641 29.613281 65.530641 29.613281 65.806641 C 29.613281 66.082641 29.837281 66.306641 30.113281 66.306641 L 48.113281 66.306641 C 48.390281 66.306641 48.613281 66.082641 48.613281 65.806641 C 48.613281 65.530641 48.389281 65.306641 48.113281 65.306641 L 30.113281 65.306641 z M 50.113281 65.306641 C 49.837281 65.306641 49.613281 65.530641 49.613281 65.806641 C 49.613281 66.082641 49.837281 66.306641 50.113281 66.306641 L 61.113281 66.306641 C 61.390281 66.306641 61.613281 66.082641 61.613281 65.806641 C 61.613281 65.530641 61.389281 65.306641 61.113281 65.306641 L 50.113281 65.306641 z M 63.113281 65.306641 C 62.837281 65.306641 62.613281 65.530641 62.613281 65.806641 C 62.613281 66.082641 62.837281 66.306641 63.113281 66.306641 L 71.113281 66.306641 C 71.390281 66.306641 71.613281 66.082641 71.613281 65.806641 C 71.613281 65.530641 71.389281 65.306641 71.113281 65.306641 L 63.113281 65.306641 z M 30.113281 72.306641 C 29.837281 72.306641 29.613281 72.530641 29.613281 72.806641 C 29.613281 73.082641 29.837281 73.306641 30.113281 73.306641 L 54.113281 73.306641 C 54.390281 73.306641 54.613281 73.082641 54.613281 72.806641 C 54.613281 72.530641 54.389281 72.306641 54.113281 72.306641 L 30.113281 72.306641 z M 57.113281 72.306641 C 56.837281 72.306641 56.613281 72.530641 56.613281 72.806641 C 56.613281 73.082641 56.837281 73.306641 57.113281 73.306641 L 70.113281 73.306641 C 70.390281 73.306641 70.613281 73.082641 70.613281 72.806641 C 70.613281 72.530641 70.389281 72.306641 70.113281 72.306641 L 57.113281 72.306641 z"/></svg>'

        /*STEP 1*/
            s1_image_url :any   =   null; 
            s1_doc_url   :any   =   null;
            s1_not_image :any   =   null;
            s1_doc_path  :any   =   null;
            file_s1_name:any    =   null;
            trans_proof:any     =   null

        /*STEP 2*/
            s2_image_url :any   =   null; 
            s2_doc_url   :any   =   null;
            s2_not_image :any   =   null;
            s2_doc_path  :any   =   null;
            file_s2_name:any    =   null;
            trust_deed:any      =   null

            toast:any = useToast(); 

            beneficiary_id:any=null;
            beneficiary_on:any=0; 

            bank_id:any     =   null;
            bank_on:any     =   0; 

        /*Place*/ 
            place_suggestion = false;
            place_list:any[]= []; 
             
        beforeCreate(){
            this.load_on=1;
        } 
        created() {       
            var js =this.local_storage=JSON.parse((localStorage.getItem(this.STORAGE_KEY) || "{}"));    
            if(typeof js!=='undefined' && typeof js['access-token']!='undefined' ){  
                this.token=js['access-token'];
            }else{  
                localStorage.removeItem(this.STORAGE_KEY); 
                this.$router.push('/sign-in'); 
            } 
            document.title = "Account Debit Form  || Caprock Merchant Platform";
            localStorage.setItem(
                'active_page', 'account_form'
            );  
        }
        async mounted(){
            this.user_name=''; 
            this.get_user_accounts(); 
            this.get_user_info();  
            await this.get_active_step(1);      
            this.get_customer_cash_ac();
            this.get_customer_securities(); 
            setTimeout(() => this.load_on=0, 500); 
        }

        data() { 
            const route         = useRoute();
            this.url_paras      = route.query; 
            this.uToken         = this.url_paras['token'];  
            this.link_code      = this.url_paras['ltoken'];  
            this.checkTokenUserType();

            return { 
                load_on             :   this.load_on, 
                customer_accounts   :   this.customer_accounts,
                user_info           :   this.user_info,      
                beneficiary         :   this.beneficiary,
                banks               :   this.banks,
                users               :   this.users,

                bank_on             :   this.bank_on,
                bank_id             :   this.bank_id,


                beneficiary_on      :   this.beneficiary_on,
                beneficiary_id      :   this.beneficiary_id,
                countries           :   this.countries,

                
                selected_ac_name    :   this.selected_ac_name,

                myValue : '',
                myOptions: [
                    {id:'1',text:'James'}
                ],
                value: 45,
                max: 100 
            }
        }

        async checkTokenUserType(){
            var uType       =   await this.getUserType(); 
            var tokenType   :any =   null;
            let form_data   = new FormData();  
            form_data.append('user_token',this.local_storage['access-token']); 
            if(typeof this.uToken !='undefined' && this.uToken!=null){
                form_data.append('token',this.uToken);  
                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'get-user-token-info';    
                await Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        } 
                    }
                )
                .then(response => { 
                    if(response.data.success==200){  
                        tokenType = response.data.userType; 
                        if(uType!=tokenType){ 
                            if(tokenType!='my'){ 
                                var cNo =tokenType.replace('business_','');     
                                this.switch_profile('business',cNo);
                            }else{
                                this.switch_profile('my',0);
                            } 
                        } 
                    }else{ 
                        this.toast.info(response.data.message);  
                    } 
                })
                .catch(error => { 
                    this.toast.error('Failed to upload');   
                    return false;
                });  

            }else{ 
                this.toast.info('Please select file first');   
            } 
        } 
        async getUserType(){
            var uType = localStorage.getItem('active_profile');
            return uType;
        } 
        async switch_profile(p_type:any,company_no=0){ 
            if(p_type=='business'){
                  /*SWITCH TO MY BUSINESS AC IN DIRECTOR*/ 
                await Common.switch_b_account(this.token,2,company_no)
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                        localStorage.setItem('active_profile','business_'+company_no); 
                        // this.profile_type = 'business';
                        location.reload();
                    }
                }).catch(e => {
                      console.log(e)
                });
            } if(p_type=='my'){
                  /*SWITCH TO INDIVIDUAL*/
                await Common.switch_b_account(this.token,1,company_no)
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                    localStorage.setItem('active_profile','my'); 
                    // this.profile_type = 'my';
                    location.reload();
                    }
                }).catch(e => {
                    console.log(e)
                });
            } 
        }




        /*Google Place API*/
            textSearch(e:any){
                clearTimeout(this.timer) 
                this.timer = setTimeout(() => {
                    Common.get_place_search(e.target.value)
                    .then(response => {   
                    if(response.status==200 && (response.data.data.results).length>0){
                        var places = response.data.data.results;   
                        $('.suggestDiv').removeClass('d-none');
                        this.place_list = [];
                        this.place_suggestion=true;
                        var list_ar:any[] = []
                        for (var i = 0; i < places.length; i++) {  
                            if(i<5){
                                var suggest     = places[i]; 
                                var input_address =  suggest.name+" "+ suggest.formatted_address;
                                if(suggest.formatted_address.includes(suggest.name)){
                                    input_address = suggest.formatted_address;
                                } 
                                this.place_list.push({
                                    id      :   i+1,
                                    title   :   suggest.name,
                                    details :   suggest.formatted_address,
                                    address :   input_address,
                                    lat     :   suggest.geometry.location.lat,
                                    long    :   suggest.geometry.location.lng  
                                });  
                            }
                        } 
                        $('.addr_section').addClass('m-0');
                        $('.place_suggest').removeClass('d-none'); 
                    } 

                    }).catch(e => {
                      console.log(e)
                    });
                }, 100)
            }
            set_address(id){
                $('#addr_'+id).removeClass('d-none');    
                var add = $('#addr_'+id).text(); 
                this.form['beneficiary_home_address']=add;   
                $('#addr_'+id).addClass('d-none');    
                $('.place_suggest').addClass('d-none');    
                $('.addr_section').removeClass('m-0');  
            }

        set_final_step(event){
            var t = event.target.value;
            if(typeof t!='undefined' && (t=='own')){
                this.final_step=4;
            }else{
                this.final_step=5;
            }
        }

        
        randomValue() {
            this.value = Math.random() * this.max
        }

        uploadFile(event){ 
            var path_item       = event.target.name+'_path';
            var item_url        = event.target.name+'_url';
            var pbar            = event.target.name+'_pbar';
            var pbarp           = event.target.name+'_pbar_p'; 
            var pdiv            = event.target.name+'_pdiv';

            this.form[pdiv]     =   1;   
            this.form[pbar]     =   0;   
            this.form[pbarp]    =  '0%';    

            
            var file        = event.target.files[0];   
            let form_data   = new FormData();  
            form_data.append('user_token',this.local_storage['access-token']);

            if(typeof file !='undefined' && file!=null){
                form_data.append('file',file); 

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'upload-file';    
                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: progressEvent => {
                            var loaded:number   =   progressEvent.loaded; 
                            var total:number    =   progressEvent.total;
                            var per             =   parseInt((loaded/total *100).toFixed());   
                            this.form[pbar]     =   per; 
                            this.form[pbarp]    =   per+'%';  

                            if(per==100){
                                this.form[pbarp]    =   'Processing';  
                            } 
                        }, 
                    }
                )
                .then(response => { 
                    if(response.data.success==200){  
                        this.form[pbarp]        =   'Upload Success';  
                        this.form[path_item]    =   response.data.file_path;     
                        this.form[item_url]     =   response.data.file_url;    
                    }else{
                        this.form[pdiv] =   0;   
                        this.form[pbar] =   0;
                        this.form[pbarp]=   '0%';
                         
                        this.toast.info(response.data.message);  
                    } 
                })
                .catch(error => {
                    this.form[pdiv] =   0;   
                    this.form[pbar] =   0;
                    this.form[pbarp]=   'Failed to upload';   
                    this.toast.error('Failed to upload');   
                    return false;
                });  

            }else{ 
                this.toast.info('Please select file first');   
            }
     
        }
     

        /*STEP ONE Functions*/
            openDoc(path){ 
                window.open(path,'_blank');
            }
            updateSubAc(event){
                var options = event.target;
                if (options.value==1) {
                    this.selected_ac_name = 'Cash';
                }
                if (options.value==3) {
                    this.selected_ac_name = 'Securities';
                }
                // console.log(options.value);  
            }
            updateRefNo(event){
                var options = event.target.options
                if (options.selectedIndex > -1) {
                    var ref_no = options[options.selectedIndex].getAttribute('ref_no');
                    if (typeof ref_no!= 'undefined' && ref_no!=null && ref_no!=''){
                        this.form['ac_ref_code']=ref_no;
                    } 
                }else{
                    this.form['ac_ref_code']='';
                }
            }

            onFileChange_s1(e) {
                const file = e.target.files[0];
                if(['image/png','image/jpeg','image/svg'].includes(file['type'])){
                    this.s1_image_url = URL.createObjectURL(file);    
                    this.file_s1_name = null; 
                    this.s2_not_image   =   0;
                }else{
                    this.s1_image_url = '';  
                    const lastDot       =   file['name'].lastIndexOf('.');
                    this.file_s1_name   =   (file['name'].substring(lastDot + 1)).toUpperCase(); 
                    this.s2_not_image   =   1;
                }
            }

            get_customer_cash_ac(){
                Common.get_customer_cash_ac(this.local_storage['access-token'],'fum,securities')
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var cash_accounts = response.data.cash_accounts;
                            var final_cash:any=[];
                            var j=0;
                            for (let i = 0; i < cash_accounts.length; i++) {  
                                if(cash_accounts[i]['is_linked']==0 || cash_accounts[i]['is_linked']=='0'){
                                    final_cash[j]=cash_accounts[i]
                                    j++;
                                }
                            }  
                            this.cash_accounts = final_cash; 
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }
            get_customer_securities(){
                Common.get_customer_securities(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var securities_accounts = response.data.secuirty_accounts; 
                            this.securities_accounts = securities_accounts; 
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }

            s1LoadError(){
                this.s1_not_image=1;
                this.s1_doc_path =this.s1_image_url;
                this.s1_image_url=''; 
            }
        /*STEP 2 Funtions*/
            country_list(){
                Common.get_all_countries(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 1) {  
                            var countries   =   response.data.data.countries;
                            this.countries  = countries;  
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }
            get_users(id='-'){
                Common.get_users(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var users   =   response.data.users; 
                            this.users  = [];  
                            if(typeof users!='undefined' && users.length>0){
                                var user =  {
                                    id      :   '-',
                                    text    :   'Select Beneficiary'
                                }
                                this.users.push(user);  
                                for (let i = 0; i < users.length; i++) {   
                                    user =  {
                                        id      :   users[i]['user_id'],
                                        text    :   users[i]['user_name']
                                    }
                                    this.users.push(user); 
                                }  
                                this.form['beneficiary_id']=id;
                            } 

                        }
                    }).catch(e => {
                      console.log(e)
                });
            }
            
            view_beneficiary(){ 
                var beneficiary_id = this.form['beneficiary_id'];
                if(typeof beneficiary_id=='undefined' || beneficiary_id=='-'){
                    this.toast.error('Please select valid beneficiary first.');
                }else{ 
                    this.beneficiary_on=1;
                    this.beneficiary_id=beneficiary_id;  
                    (this.$refs['bnF'] as any).openModal('beneficiary_details');
                    (this.$refs['bnF'] as any).get_beneficiary_info(this.local_storage['access-token'],beneficiary_id); 
                }

            } 
            get_beneficiary_list(id='-'){
                Common.get_beneficiary_list(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var beneficiary   =   response.data.beneficiary; 

                            this.beneficiary  = [];  
                            var user =  {
                                id      :   '-',
                                text    :   'Select Payer'
                            }
                            this.beneficiary.push(user);  
                            if(typeof beneficiary!='undefined' && beneficiary.length>0){
                                for (let i = 0; i < beneficiary.length; i++) {   
                                    user =  {
                                        id      :   beneficiary[i]['beneficiary_id'],
                                        text    :   beneficiary[i]['beneficiary_name']
                                    }
                                    this.beneficiary.push(user); 
                                }  
                                this.form['payer_id']=id;
                            }   
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }


            /* view_bank(){ 
                var bank_id = this.form['bank_id'];
                if(typeof bank_id=='undefined' || bank_id=='-'){
                    this.toast.error('Please select valid external bank first.');
                }else{ 
                    this.bank_on    =   1;
                    this.bank_id    =   bank_id;  
                    (this.$refs['exBanks'] as any).openModal('bank_details');
                    (this.$refs['exBanks'] as any).get_bank_info(this.local_storage['access-token'],bank_id); 
                } 
            } */ 
            get_bank_list(id='-'){
                Common.app_bank_accounts(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var banks   =   response.data.bank_accounts; 

                            this.banks  = [];  
                            var bank =  {
                                id      :   '-',
                                text    :   'Select Bank Account'
                            }
                            this.banks.push(bank);  
                            if(typeof banks!='undefined' && banks.length>0){
                                for (let i = 0; i < banks.length; i++) {   
                                    bank =  {
                                        id      :   banks[i]['bank_id'],
                                        text    :   banks[i]['bank_name']
                                    }
                                    this.banks.push(bank); 
                                }  

                                if(typeof(id)!='undefined' && id!='undefined' && id!=null ){
                                    this.form['bank_id']=id; 
                                }else{
                                    this.form['bank_id']='-'; 
                                }
                                 
                            }    
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }

             
            get_currencies(){
                Common.currency_list(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var currencies   =   response.data.currencies; 
                            this.currencies  = [];  
                            if(typeof currencies!='undefined' && currencies.length>0){
                                this.currencies =currencies;
                                // var user =  {
                                //     id      :   '-',
                                //     text    :   'Select Currency'
                                // }
                                // this.currencies.push(user);  
                                // for (let i = 0; i < currencies.length; i++) {   
                                //     user =  {
                                //         id      :   currencies[i]['user_id'],
                                //         text    :   currencies[i]['user_name']
                                //     }
                                //     this.currencies.push(user); 
                                // }  
                                // this.form['beneficiary_id']=id;
                            } 

                        }
                    }).catch(e => {
                      console.log(e)
                });
            }


            onFileChange_s2(e) {
                const file = e.target.files[0];
                if(['image/png','image/jpeg','image/svg'].includes(file['type'])){
                    this.s2_image_url = URL.createObjectURL(file);    
                    this.file_s2_name = null;
                    this.s2_not_image = 0;
                }else{
                    this.s2_image_url   =   '';  
                    this.s2_not_image   =   1;
                    const lastDot       =   file['name'].lastIndexOf('.');
                    this.file_s2_name   =   (file['name'].substring(lastDot + 1)).toUpperCase();
                }
            } 
            s2LoadError(){
                this.s2_not_image=1;
                this.s2_doc_path =this.s2_image_url;
                this.s2_image_url=''; 
            }


            myChangeEvent(val){
                console.log(val);
            }
            mySelectEvent({id, text}){
                console.log({id, text})
            } 
            submitForm_2(){
                this.load_on=1; 
                var form_records  = JSON.parse(JSON.stringify((this.form)));  
                

                let form_data = new FormData();  
                form_data.append('user_token',this.local_storage['access-token']);
                form_data.append('beneficiary_type',form_records['beneficiary_type']);
                form_data.append('bank_id',form_records['bank_id']);
                form_data.append('beneficiary_id',form_records['beneficiary_id']);
                form_data.append('beneficiary_name',form_records['beneficiary_name']);
                form_data.append('beneficiary_company_reg_no',form_records['beneficiary_company_reg_no']);
                form_data.append('beneficiary_structure',form_records['beneficiary_structure']);
                form_data.append('beneficiary_nationality',form_records['beneficiary_nationality']);
                form_data.append('beneficiary_reg_country',form_records['beneficiary_reg_country']) ;

                form_data.append('beneficiary_user_type',form_records['beneficiary_user_type']) ;
                form_data.append('beneficiary_passport_no',form_records['beneficiary_passport_no']) ;
                form_data.append('beneficiary_passport_expiry',form_records['beneficiary_passport_expiry']) ;
                form_data.append('beneficiary_passport_country',form_records['beneficiary_passport_country']) ;
                form_data.append('beneficiary_passport_no',form_records['beneficiary_passport_no']) ;
                form_data.append('beneficiary_dob',form_records['beneficiary_dob']) ;
                form_data.append('beneficiary_home_address',form_records['beneficiary_home_address']) ;
                form_data.append('beneficiary_email_id',form_records['beneficiary_email_id']) ;
                form_data.append('beneficiary_phone_no',form_records['beneficiary_phone_no']) ;
                form_data.append('beneficiary_trust',form_records['beneficiary_trust']) ;
                form_data.append('beneficiary_usa_citizen',form_records['beneficiary_usa_citizen']) ;
                form_data.append('beneficiary_tax_resident_usa',form_records['beneficiary_tax_resident_usa'])  ;
                form_data.append('beneficiary_social_security_no',form_records['beneficiary_social_security_no'])    ;
                form_data.append('beneficiary_tax_id',form_records['beneficiary_tax_id']);
                
                if(typeof this.trust_deed !='undefined' && this.trust_deed!=null){
                    form_data.append('trust_deed',this.trust_deed); 
                }



                var message = '';
                var error   = 0;
                if(form_records['beneficiary_type']=='existing' && (typeof form_records['beneficiary_id']=='undefined' || form_records['beneficiary_id']=='-' || form_records['beneficiary_id']=='')){
                    error   = 1;
                    message = 'Please select beneficiary first';
                } 
                if(form_records['beneficiary_type']=='own' && (typeof form_records['bank_id']=='undefined' || form_records['bank_id']=='-' || form_records['bank_id']=='')){
                    error   = 1;
                    message = 'Please select external bank first';
                } 
                if(error!=0){
                    setTimeout(() => this.load_on=0, 500);  
                    this.toast.error(message);
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trans-request-d2';   
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =    parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==3 || this.next_step=='3'){
                                this.set_step(3); 
                            }else{ 
                                this.set_step(2); 
                            }
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.success(response.data.message);
                        }else{ 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error('Internal Error');
                    });  
                }  
            }

        /*STEP 3 Funtions*/

            submitForm_3(){
                this.load_on=1; 
                var form_records  = JSON.parse(JSON.stringify((this.form)));   
                let form_data = new FormData();  
                
                form_data.append('user_token'                   ,this.local_storage['access-token']);
                form_data.append('payment_amount'               ,form_records['payment_amount']);
                form_data.append('payment_currency'             ,form_records['payment_currency']);
                form_data.append('payment_type'                 ,form_records['payment_type']);
                form_data.append('bank_name'                    ,form_records['bank_name']);
                form_data.append('bank_address'                 ,form_records['bank_address']);
                form_data.append('bank_swift_code'              ,form_records['bank_swift_code']);  
                form_data.append('bank_ac_name'                 ,form_records['bank_ac_name']); 
                form_data.append('bank_ac_no'                   ,form_records['bank_ac_no']); 
                form_data.append('beneficiary_ref_no'                 ,form_records['beneficiary_ref_no']); 
                form_data.append('your_ref_no'                  ,form_records['your_ref_no']); 
                form_data.append('payment_transmission_type'    ,form_records['payment_transmission_type']); 
                form_data.append('bank_officer_name'            ,form_records['bank_officer_name']); 
                form_data.append('bank_officer_phone_no'        ,form_records['bank_officer_phone_no']); 
                form_data.append('bank_officer_email_address'   ,form_records['bank_officer_email_address']);  

                var message = '';
                var error   = 0; 
                if(error!=0){ 
                    this.toast.error(message);
                    setTimeout(() => this.load_on=0, 500); 
                }else{ 

                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trans-request-d3';   
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =    parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==4 || this.next_step=='4'){
                                this.set_step(4); 
                            }else{ 
                                this.set_step(3); 
                            }
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.success(response.data.message);
                        }else{ 
                            setTimeout(() => this.load_on=0, 500); 
                            this.toast.error(response.data.message); 
                        } 
                    })
                    .catch(error => {
                        this.toast.error('internal error'); 
                        setTimeout(() => this.load_on=0, 500); 
                    });  
                } 
            }

        /*STEP 4 Funtions*/ 
            submitForm_4(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records  = JSON.parse(JSON.stringify((this.form)));   
                let form_data = new FormData();  
                
                form_data.append('user_token'               ,this.local_storage['access-token']); 
                form_data.append('esign_name'               ,form_records['esign_name']);
                form_data.append('esign_phone_no'           ,form_records['esign_phone_no']);
                form_data.append('esign_dob'                ,form_records['esign_dob']);
                form_data.append('esign_email_id'           ,form_records['esign_email_id']); 

                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message); 

                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trans-request-d4';   
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =    parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==200 || this.next_step=='200'){  
                                this.request_verified=1;
                                this.save_request(1);
                            }else if(this.next_step==5 || this.next_step=='5'){
                                this.set_step(5); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }else{ 
                                this.set_step(4); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }

                            /*if(this.next_step==5 || this.next_step=='5'){
                                this.set_step(5); 
                            }else{ 
                                this.set_step(4); 
                            }
                            setTimeout(() => this.load_on=0, 500);   
                            this.toast.success(response.data.message);*/
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('INternal Error');
                    });  
                } 
            }

        /*STEP 5 Funtions*/ 
            submitForm_5(){
                setTimeout(() => this.load_on=1,100); 
                var form_records    =   JSON.parse(JSON.stringify((this.form)));   
                let form_data       =   new FormData();  
                
                 var is_colour_passport              =  typeof form_records['is_colour_passport']!='undefined' ? form_records['is_colour_passport'] :'';
                var colour_passport_path            =  typeof form_records['colour_passport_path']!='undefined' ? form_records['colour_passport_path'] :'';

                var is_residence_proof              =  typeof form_records['is_residence_proof']!='undefined' ? form_records['is_residence_proof'] :'';
                var residence_proof_path            =  typeof form_records['residence_proof_path']!='undefined' ? form_records['residence_proof_path'] :'';
                
                var is_contract_proof               =  typeof form_records['is_contract_proof']!='undefined' ? form_records['is_contract_proof'] :'';
                var contract_proof_path             =  typeof form_records['contract_proof_path']!='undefined' ? form_records['contract_proof_path'] :'';
                
                var is_incorporation_certi          =  typeof form_records['is_incorporation_certi']!='undefined' ? form_records['is_incorporation_certi'] :'';
                var incorporation_certi_path        =  typeof form_records['incorporation_certi_path']!='undefined' ? form_records['incorporation_certi_path'] :'';
                
                var is_driver_license               =  typeof form_records['is_driver_license']!='undefined' ? form_records['is_driver_license'] :'';
                var driver_license_path             =  typeof form_records['driver_license_path']!='undefined' ? form_records['driver_license_path'] :'';
 
                form_data.append('user_token'                   ,this.local_storage['access-token']); 
                
                form_data.append('is_colour_passport'           ,is_colour_passport);
                form_data.append('colour_passport_path'         ,colour_passport_path);
                
                form_data.append('is_residence_proof'           ,is_residence_proof);
                form_data.append('residence_proof_path'         ,residence_proof_path);

                form_data.append('is_contract_proof'            ,is_contract_proof);
                form_data.append('contract_proof_path'          ,contract_proof_path); 
                
                form_data.append('is_incorporation_certi'       ,is_incorporation_certi);
                form_data.append('incorporation_certi_path'     ,incorporation_certi_path); 
                
                form_data.append('is_driver_license'            ,is_driver_license);
                form_data.append('driver_license_path'          ,driver_license_path);

 

                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message); 
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-trans-request-d5';   
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: progressEvent => {
                                var loaded:number   =   progressEvent.loaded; 
                                var total:number    =   progressEvent.total;
                                var per             =   parseInt((loaded/total *100).toFixed());    
                            }  
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==200 || this.next_step=='200'){  
                                this.request_verified=1;
                                this.save_request(1);
                            }else{   
                                this.set_step(5); 
                                setTimeout(() => this.load_on=0, 500); 
                                this.toast.success(response.data.message);  
                            }
                        }else{ 
                            setTimeout(() => this.load_on=0, 500); 
                            this.toast.error(response.data.message);   
                        } 
                    })
                    .catch(error => { 
                        this.toast.info('Internal Error');  
                        setTimeout(() => this.load_on=0, 500); 
                    });  
                } 
            }

            openModal(id: any) {
                $('#' + id).addClass('d-block');
                $('#' + id).addClass('show');
                $('#' + id).css('overflow-y', 'scroll');
            }
            closeModal(id: any,reload=false) {
                $('#' + id).removeClass('d-block');
                $('#' + id).addClass('d-none');
                $('#' + id).removeClass('show');
                if(reload==true){
                    location.reload();
                }
            }  
            cancel_request(req_type=1){ 
                this.load_on=1; 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('user_token'   ,this.local_storage['access-token']); 
                form_data.append('req_type'     ,req_type.toString());                    

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'trans-request-cancel';   
                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: function( progressEvent:any ) {
                            var loaded:number   =   progressEvent.loaded;
                            var total:number    =   progressEvent.total;
                            var per             =    parseInt((loaded/total *100).toFixed());  
                        }.bind(this)
                    }
                )
                .then(response => { 
                    if(response.data.success==200){ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.success(response.data.message);   
                        setTimeout(() => this.$router.push('/'), 500); 
                        
                    }else{ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error(response.data.message);   
                    } 
                })
                .catch(error => { 
                    setTimeout(() => this.load_on=0, 500); 
                    this.toast.error('Internal Error');   
                });   
            }

            save_request(req_type=1){
                this.load_on=1; 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('user_token'   ,this.local_storage['access-token']); 
                form_data.append('req_type'     ,req_type.toString()); 

                 
                if(this.request_verified==0){
                    setTimeout(() => this.load_on=0, 500); 
                    this.toast.info('Please verify and click finish button in upload section');   
                }else{ 

                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'trans-request-verify';   
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =    parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){ 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.success(response.data.message);   
                            setTimeout(() => this.$router.push('/'), 500); 
                            
                        }else{ 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);   
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('Internal Error');   
                    });  
                } 
            }






        /*STEP MANAGEMENT*/ 
            async get_active_step(id=0) { 
                await Common.get_active_trans_req_step(this.local_storage['access-token'],1)
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200 && response.data.old_request ==1) {   
                            var req=response.data.trans_request;  
                            this.req_details = req; 
                            if(typeof req['req_records']!='undefined' && req['req_records']!=''){
                                this.records  = JSON.parse(req['req_records']); 
                                this.records['trans_proof_url'] = req['trans_proof_url']; 
                                this.records['trust_deed_url']  = req['trust_deed_url']; 


                                this.records['colour_passport_url']     = req['colour_passport_url']; 
                                this.records['residence_proof_url']     = req['residence_proof_url']; 
                                this.records['contract_proof_url']      = req['contract_proof_url']; 
                                this.records['incorporation_certi_url'] = req['incorporation_certi_url']; 
                                this.records['driver_license_url']      = req['driver_license_url']; 



                            } 
                            var c_steps =  this.req_details['req_completed_steps'];
                            if(typeof c_steps!='undefined' && c_steps!=''){
                                this.completed_steps = c_steps.split(",").map(Number);
                            }   

                            if(typeof this.records['beneficiary']!='undefined' && typeof this.records['beneficiary']['beneficiary_type']!='undefined' && (this.records['beneficiary']['beneficiary_type']=='existing' || this.records['beneficiary']['beneficiary_type']=='own')){ 
                                this.final_step = 4; 
                            } else{
                                this.final_step = 5; 
                            }


                            if(id==1){ 
                                this.current_step=req['req_current_step'];    
                                if(this.current_step==5){
                                    this.current_step=this.final_step;  
                                }  
                                setTimeout(() => this.set_step(this.current_step), 200); 
                            }  
                            return true;
                        }else{
                            this.current_step   =   1;
                            this.fresh_step     =   1;
                            this.set_step(1);
                            return true;
                        }
                    }).catch(e => {
                        console.log(e)
                        return true;
                });
                
            } 

            async set_step(step_id){   
                var prev_step = (step_id-1);  
                if(this.fresh_step==0){
                    await this.get_active_step(); 
                } 
                if(!this.completed_steps.includes(prev_step) && prev_step!=0){ 
                    this.toast.error('Please complete previous step first.');   
                    setTimeout(() => this.load_on=0, 500);
                }else{
                    this.load_on=1; 
                    if(typeof step_id!='undefined' && step_id==1){  
                        
                        this.current_step =1;  
                        this.active_tab ='account';

                        var account = this.records['account'];
                        if(typeof this.records['account']!=='undefined' ){ 
                            this.form['ac_id']      =   account['ac_id'];
                            this.form['cashac_id'] =account['cashac_id'];
                            this.form['payment_reason'] =account['payment_reason'];
                            for (let i = 0; i < this.cash_accounts.length; i++) {   
                                if(this.cash_accounts[i]['subac_id']==account['cashac_id']){  
                                    this.form['ac_ref_code']=this.cash_accounts[i]['subac_reference_code'];
                                }  
                            }   
                            this.s1_image_url   =   this.req_details['trans_proof_url'];
                            this.s1_doc_url     =   this.req_details['trans_proof_url'];
                            this.file_s1_name   =   this.records['account']['real_file_name'];  
                        }   
                        setTimeout(() => this.load_on=0, 500);

                    }else if(typeof step_id!='undefined' && (step_id==2)){  
                        await this.country_list();  
                        this.current_step   =   2;  
                        this.active_tab     =   'beneficiary'; 
 
                        if(typeof this.records['beneficiary']!=='undefined' ){ 
                            var beneficiary = this.records['beneficiary'];
                            this.form['beneficiary_name']               =beneficiary['beneficiary_name'];
                            this.form['beneficiary_type']               =beneficiary['beneficiary_type'];
                            this.form['beneficiary_id']                 =beneficiary['beneficiary_id']; 
                            this.form['bank_id']                        =beneficiary['bank_id'];
                            
                            if(beneficiary['beneficiary_type']=='new'){
                                this.form['beneficiary_user_type']            =beneficiary['beneficiary_user_type'];
                                this.form['beneficiary_company_reg_no']       =beneficiary['beneficiary_company_reg_no'];
                                this.form['beneficiary_nationality']          =beneficiary['beneficiary_nationality'];
                                this.form['beneficiary_reg_country']          =beneficiary['beneficiary_reg_country'];
                                this.form['beneficiary_structure']            =beneficiary['beneficiary_structure'];
                                this.form['beneficiary_passport_no']          =beneficiary['beneficiary_passport_no'];
                                this.form['beneficiary_passport_expiry']      =beneficiary['beneficiary_passport_expiry'];
                                this.form['beneficiary_passport_country']     =beneficiary['beneficiary_passport_country'];
                                this.form['beneficiary_dob']                  =beneficiary['beneficiary_dob'];
                                this.form['beneficiary_home_address']         =beneficiary['beneficiary_home_address'];
                                this.form['beneficiary_email_id']             =beneficiary['beneficiary_email_id'];
                                this.form['beneficiary_phone_no']             =beneficiary['beneficiary_phone_no']; 
                                this.form['beneficiary_trust']                =beneficiary['beneficiary_trust'].toString(); 
                                this.form['beneficiary_usa_citizen']          =beneficiary['beneficiary_usa_citizen'].toString(); 
                                this.form['beneficiary_tax_resident_usa']     =beneficiary['beneficiary_tax_resident_usa'].toString(); 
                                
                                this.form['beneficiary_tax_id']               =beneficiary['beneficiary_tax_id']; 
                                this.form['beneficiary_social_security_no']   =beneficiary['beneficiary_social_security_no'];  
                                this.s2_image_url   =   this.req_details['trust_deed_url'];
                                this.s2_doc_url     =   this.req_details['trust_deed_url'];
                                this.file_s2_name   =   this.records['beneficiary']['real_file_name'];  
                            }

                            

                        }   
                        /*await this.get_users(this.form['beneficiary_id']);*/
                        await this.get_beneficiary_list(this.form['beneficiary_id']);
                        await this.get_bank_list(this.form['bank_id']);
                        setTimeout(() => this.load_on=0, 500);
     
                        
                    }else if(typeof step_id!='undefined' && step_id==3){  
                        await this.get_currencies();     
                        this.current_step   =   3;  
                        this.active_tab     =   'payment_details';      
                        var payment_details:any = this.records['payment_details']; 
                        if(typeof this.records['payment_details']!=='undefined' ){   
                            this.form['payment_amount']            =   payment_details['payment_amount'];
                            this.form['payment_currency']          =   payment_details['payment_currency'];
                            this.form['payment_type']              =   payment_details['payment_type'];
                            this.form['bank_name']                 =   payment_details['bank_name'];
                            this.form['bank_address']              =   payment_details['bank_address'];
                            this.form['bank_swift_code']           =   payment_details['bank_swift_code'];
                            this.form['bank_ac_name']              =   payment_details['bank_ac_name'];
                            this.form['bank_ac_no']                =   payment_details['bank_ac_no'];
                            this.form['beneficiary_ref_no']        =   payment_details['beneficiary_ref_no'];
                            this.form['your_ref_no']               =   payment_details['your_ref_no'];
                            this.form['payment_transmission_type'] =   payment_details['payment_transmission_type'];
                            
                            this.form['bank_officer_name']         =   payment_details['bank_officer_name']!='undefined' ? payment_details['bank_officer_name']:'';
                            
                            this.form['bank_officer_phone_no']     =   payment_details['bank_officer_phone_no']!='undefined' ? payment_details['bank_officer_phone_no']:''; 
                            
                            this.form['bank_officer_email_address']=   payment_details['bank_officer_email_address']!='undefined' ? payment_details['bank_officer_email_address']:''; 
                            
                            // this.form['bank_officer_name']         =   payment_details['bank_officer_name'];
                            // this.form['bank_officer_phone_no']     =   payment_details['bank_officer_phone_no'];
                            // this.form['bank_officer_email_address']=   payment_details['bank_officer_email_address']; 
                        }     
                        setTimeout(() => this.load_on=0, 500);
                    }else if(typeof step_id!='undefined' && step_id==4){  
                        this.current_step   =   4;  
                        this.active_tab     =   'e_signature';         
                        var e_signature:any = this.records['e_signature']; 
                        if(typeof this.records['e_signature']!=='undefined' ){   
                            this.form['esign_dob']          =   e_signature['esign_dob'];
                            this.form['esign_name']         =   e_signature['esign_name'];
                            this.form['esign_email_id']     =   e_signature['esign_email_id'];
                            this.form['esign_phone_no']     =   e_signature['esign_phone_no'];  
                        }     
                        setTimeout(() => this.load_on=0, 500);
                    }else if(typeof step_id!='undefined' && step_id==5){    
                        this.current_step   =   5;  
                        this.active_tab     =   'upload';         
                         
                          
                        if(typeof this.records['upload']!=='undefined' ){   
                            var upload:any      =   this.records['upload']; 
                            this.form['is_colour_passport']                 =   typeof upload['is_colour_passport']!='undefined' && upload['is_colour_passport']!=null ?upload['is_colour_passport'].toString():'';
                            this.form['colour_passport_path']               =   upload['colour_passport_path'];
                            this.form['is_residence_proof']                 =   typeof upload['is_residence_proof']!='undefined' && upload['is_residence_proof']!=null ?upload['is_residence_proof'].toString():'';
                            this.form['residence_proof_path']               =   upload['residence_proof_path'];
                            this.form['is_contract_proof']                  =   typeof upload['is_contract_proof']!='undefined' && upload['is_contract_proof']!=null ?upload['is_contract_proof'].toString():'';
                            this.form['contract_proof_path']                =   upload['contract_proof_path'];
                            this.form['is_incorporation_certi']             =   typeof upload['is_incorporation_certi']!='undefined' && upload['is_incorporation_certi']!=null ?upload['is_incorporation_certi'].toString():'';
                            this.form['incorporation_certi_path']           =   upload['incorporation_certi_path'];
                            this.form['is_driver_license']                  =   typeof upload['is_driver_license']!='undefined' && upload['is_driver_license']!=null ?upload['is_driver_license'].toString():'';
                            this.form['driver_license_path']                =   upload['driver_license_path']; 
                        }   
                        setTimeout(() => this.load_on=0, 500);
                    }else{ 
                        this.set_step(1);
                    }
                } 
            }


            submitForm_1(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records  = JSON.parse(JSON.stringify((this.form)));  
                
                let form_data = new FormData();  
                form_data.append('user_token',this.local_storage['access-token']);
                form_data.append('ac_id',form_records['ac_id']);
                form_data.append('cashac_id',form_records['cashac_id']);
                form_data.append('payment_reason',form_records['payment_reason']); 
                
                if(this.trans_proof!=null && this.trans_proof!=''){
                    form_data.append('trans_proof',this.trans_proof); 
                }
                

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'save-trans-request-d1';  

                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: function( progressEvent:any ) {
                            var loaded:number   =   progressEvent.loaded;
                            var total:number    =   progressEvent.total;
                            var per             =    parseInt((loaded/total *100).toFixed());  
                        }.bind(this)
                    }
                )
                .then(response => { 
                    if(response.data.success==200){
                        this.fresh_step=0;
                        if(this.next_step==2 || this.next_step=='2'){
                            this.set_step(2); 
                        }else{ 
                            this.set_step(1);  
                        }
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.success(response.data.message);   
                    }else{ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error(response.data.message);   
                    } 
                })
                .catch(error => {
                    setTimeout(() => this.load_on=0, 500);   
                });   
            }
            
            
     
        /*GENERAL */ 
            fetch_file(event:any){  
              var file = event.target.files[0];  
              if(event.target.name=='trans_proof') {
                this.trans_proof= file; 
              }
              if(event.target.name=='trust_deed') {
                this.trust_deed= file; 
              } 
            }
            get_user_accounts() { 
                Common.get_user_accounts(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) { 
                            this.customer_accounts=response.data.accounts;
                            this.total_ac_balance   =   response.data.t_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) ;  
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }
            get_user_info() { 
                Common.get_user_info(this.local_storage['access-token'])
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var user_inf=response.data.profile; 
                            user_inf.join_date=user_inf.join_date?moment(user_inf.join_date).format('DD MMM YYYY '):'';
                            this.user_info=user_inf;
                        }
                    }).catch(e => {
                      console.log(e)
                });
            } 


        /*FORM VALIDATIONS*/ 
            /*validateEmail(value) { 
                if (!value) {
                    return 'This field is required';
                } 
                const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                if (!regex.test(value)) {
                    return 'This field must be a valid email';
                } 
                return true;
            }  */
            validateEmail(value) { 
                const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                if (typeof value!='undefined' && !regex.test(value)) { 
                    return 'This field must be a valid email'; 
                } 
                return true;
            }  
            requiredField(value) { 
                if (!value) {
                    return 'This field is required';
                } 
                return true;
            }
            selectField(value) { 
                if (!value || value=='') {
                    return 'Please select one of option';
                } 
                return true;
            }
            /*mobileField(value){
                if (!value) {
                    return 'This field is required';
                } 
                var phoneNum = value.replace(/[^\d]/g, '');
                if(phoneNum.length <7 || phoneNum.length > 12) {  
                    return 'This field must be a valid mobile number';
                } 
                return true; 
            }*/
            mobileField(value){ 
                if(typeof value!='undefined'){
                    var phoneNum = value.replace(/[^\d]/g, '');
                    if(phoneNum.length <7 || phoneNum.length > 12) {  
                        return 'This field must be a valid mobile number';
                    }  
                    return true;
                }
                return true; 
            } 

    }
